var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraft = function SvgDraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18zm331-554v-186H220v680h520v-494zM220-820v186zv680z"
  })));
};
export { SvgDraft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIgogIHdpZHRoPSIyNCIKPgogIDxwYXRoCiAgICBkPSJNMjIwLTgwcS0yNCAwLTQyLTE4dC0xOC00MnYtNjgwcTAtMjQgMTgtNDJ0NDItMThoMzYxbDIxOSAyMTl2NTIxcTAgMjQtMTggNDJ0LTQyIDE4SDIyMFptMzMxLTU1NHYtMTg2SDIyMHY2ODBoNTIwdi00OTRINTUxWk0yMjAtODIwdjE4Ni0xODYgNjgwLTY4MFoiCiAgLz4KPC9zdmc+Cg==";